// @flow
import React from 'react';
import coolicon from '../../assets/images/partners/coolicon.svg';
import styles from './PartnerCard.module.scss';

interface ICard {
  partner_name: string;
  sections?: [
    {
      id: number;
      title: string;
      description: string[];
    }
  ];
  text?: string;
  text2?: string;
  linktext: string;
  linkadress: string;
  image: string;
  sub_title?: string;
}

type IPartnerCard = {
  style: string;
  card: ICard;
}

const PartnerCard = ({ style, card }: IPartnerCard) => (
  <div>
    <div className={style}>
      <div className={styles.image}>
        <img
          className={styles.img}
          src={card.image}
          alt="card"
        />
      </div>
      <div className={styles.cardtext}>
        <div className={styles.local_header}>{card.partner_name}</div>
        {card.sections?.map((section) => (
          <div key={section.title}>
            <div className={styles.text}>{section.title}</div>
            {section.description.map((items) => (
              <div className={styles.text} key={items}>{items}</div>
            ))}
          </div>
        ))}
        {card.sub_title && (
        <div className={styles.text}>{card.sub_title}</div>
        )}
        {card.text && (
        <div className={styles.text}>{card.text}</div>
        )}
        <hr className={styles.hr} />
        <div className={styles.linkbox}>
          <a
            className={styles.link}
            target="/blank"
            href={card.linkadress}
          >
            {card.linktext}
            <div className={styles.linkicon}>
              <img
                src={coolicon}
                width={16}
                height={16}
                alt="icon"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default PartnerCard;
